import { environment } from '../../../environments/environment';
import { Utility } from '../utility';

export const emojiPiLiTu = {
    label: '霹雳兔',
    height: 90,
    width: 90,
    path:"/upload/facetime/pilitu/",
    range:[[20210501,20210516]]
    // items: [
    //     {
    //         'not': 20210501,
    //         'id': 20210501,
    //         'image': '/upload/facetime/pilitu/20210501.gif',
    //         'title': 'OK',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210501)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210502,
    //         'id': 20210502,
    //         'image': '/upload/facetime/pilitu/20210502.gif',
    //         'title': 'ROCK',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210502)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210503,
    //         'id': 20210503,
    //         'image': '/upload/facetime/pilitu/20210503.gif',
    //         'title': 'YEAH',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210503)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210504,
    //         'id': 20210504,
    //         'image': '/upload/facetime/pilitu/20210504.gif',
    //         'title': '吃瓜',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210504)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210505,
    //         'id': 20210505,
    //         'image': '/upload/facetime/pilitu/20210505.gif',
    //         'title': '锤爆',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210505)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210506,
    //         'id': 20210506,
    //         'image': '/upload/facetime/pilitu/20210506.gif',
    //         'title': '打你',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210506)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210507,
    //         'id': 20210507,
    //         'image': '/upload/facetime/pilitu/20210507.gif',
    //         'title': '滚',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210507)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210508,
    //         'id': 20210508,
    //         'image': '/upload/facetime/pilitu/20210508.gif',
    //         'title': '哈哈哈',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210508)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210509,
    //         'id': 20210509,
    //         'image': '/upload/facetime/pilitu/20210509.gif',
    //         'title': '嗨',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210509)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210510,
    //         'id': 202105010,
    //         'image': '/upload/facetime/pilitu/20210510.gif',
    //         'title': '洪荒',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210510)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210511,
    //         'id': 20210511,
    //         'image': '/upload/facetime/pilitu/20210511.gif',
    //         'title': '亮相',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210511)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210512,
    //         'id': 20210512,
    //         'image': '/upload/facetime/pilitu/20210512.gif',
    //         'title': '你说',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210512)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210513,
    //         'id': 20210513,
    //         'image': '/upload/facetime/pilitu/20210513.gif',
    //         'title': '亲亲',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210513)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210514,
    //         'id': 20210514,
    //         'image': '/upload/facetime/pilitu/20210514.gif',
    //         'title': '无辜',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210514)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210515,
    //         'id': 20210515,
    //         'image': '/upload/facetime/pilitu/20210515.gif',
    //         'title': '小样儿',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210515)',
            
    //         'GroupID': 202105
    //     },
    //     {
    //         'not': 20210516,
    //         'id': 20210516,
    //         'image': '/upload/facetime/pilitu/20210516.gif',
    //         'title': '兴奋',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210516)',
            
    //         'GroupID': 202105
    //     },
    // ]
}
